import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "26",
  fill: "none",
  viewBox: "0 0 30 26"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "27.2",
      height: "23.2",
      x: "1.4",
      y: "1.4",
      stroke: "#555F71",
      "stroke-width": ".8",
      rx: "1.6"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#555F71",
      d: "M8.997 9v8h-1.45v-6.59h-.046L5.63 11.605v-1.328L7.618 9zM14.147 17.11q-.87 0-1.547-.294-.673-.293-1.054-.8a1.88 1.88 0 0 1-.375-1.16q-.004-.504.218-.926.224-.423.602-.703.383-.285.851-.364v-.054a1.7 1.7 0 0 1-1-.63 1.8 1.8 0 0 1-.375-1.144 1.82 1.82 0 0 1 .344-1.101q.348-.485.953-.762a3.25 3.25 0 0 1 1.383-.281q.77 0 1.371.28.605.279.953.763.352.484.352 1.101 0 .648-.387 1.145a1.7 1.7 0 0 1-.988.629v.054q.469.078.844.364.378.28.601.703.227.421.227.925 0 .65-.383 1.16t-1.055.801q-.668.294-1.535.293m0-1.118q.45 0 .781-.152.333-.156.516-.438.184-.28.187-.648a1.2 1.2 0 0 0-.199-.676 1.3 1.3 0 0 0-.527-.465 1.66 1.66 0 0 0-.758-.168 1.7 1.7 0 0 0-.766.168 1.34 1.34 0 0 0-.53.465q-.192.292-.188.676-.005.367.18.648.183.278.515.434.336.156.79.156m0-3.644q.367 0 .649-.149a1.13 1.13 0 0 0 .617-1.027 1.14 1.14 0 0 0-.164-.602 1.06 1.06 0 0 0-.446-.402 1.4 1.4 0 0 0-.656-.145q-.378 0-.668.145-.285.141-.445.402a1.1 1.1 0 0 0-.153.602q-.003.348.157.613.164.263.449.414.29.15.66.149M21.054 15.719v-5.406h1.227v5.406zm-2.09-2.09v-1.227h5.406v1.227z"
    }, null, -1)
  ])))
}
export default { render: render }